import { Link } from "react-router-dom";
import { Send } from "lucide-react";
import GscSettingsCard from "../GscSettingsCard";
import BulkIndexingCard from "../BulkIndexingCard";
import { Card, PRIMARY, useSettings } from "./shared";

export function SearchConsoleSection() {
  const { setGscConnected } = useSettings();
  return <GscSettingsCard onConnectionChange={setGscConnected} />;
}

export function IndexingSection() {
  const { gscConnected, loading } = useSettings();
  if (loading) return <p className="text-xs text-zinc-400">Loading…</p>;
  if (!gscConnected) {
    return (
      <Card icon={Send} title="Bulk Indexing" subtitle="Google Indexing API — 200 URLs/day">
        <p className="text-xs text-zinc-500">
          Bulk Indexing submits through your Google Search Console connection.{" "}
          <Link to="/dashboard/settings/search-console" className="font-bold underline" style={{ color: PRIMARY }}>
            Connect Search Console
          </Link>{" "}
          first.
        </p>
      </Card>
    );
  }
  return <BulkIndexingCard isGscConnected />;
}
